module.exports = __webpack_public_path__ + "assets/GTAmerica-Regular.woff2";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GTAmerica-Regular.woff2
// module id = 1017
// module chunks = 19